import { Store, Building2, Warehouse, Car, Package, MapPin } from "lucide-react";

export const OPERACIONES = [
  { value: "traspaso", label: "Traspaso" },
  { value: "alquiler", label: "Alquiler" },
  { value: "venta", label: "Venta" },
  { value: "rentabilidad", label: "Venta en Rentabilidad" },
] as const;

export type Operacion = (typeof OPERACIONES)[number]["value"];

export const TIPOS_LOCAL = [
  { value: "comercial", label: "Local comercial", icon: Store },
  { value: "oficina", label: "Oficina", icon: Building2 },
  { value: "nave", label: "Nave", icon: Warehouse },
  { value: "parking", label: "Parking - garaje", icon: Car },
  { value: "trastero", label: "Trastero", icon: Package },
  { value: "otros", label: "Otros locales", icon: MapPin },
] as const;

export type TipoLocal = (typeof TIPOS_LOCAL)[number]["value"];
